import { MiteneFormattedMessage } from 'components/atoms/MiteneFormattedMessage'
import { type FC } from 'react'
import { Radio } from '../Radio'
import { Text } from '../Typography'
import { FormattedMessage } from 'react-intl'

export interface PlanCardProps {
  price: string
  period: 'month' | 'year'
  checked: boolean
  priceId: string
  onSelect: (priceId: string) => void
  discountedMonthlyPrice?: string
  subscribed: boolean
}

export const PlanCard: FC<PlanCardProps> = ({
  price,
  period,
  checked,
  priceId,
  onSelect,
  discountedMonthlyPrice,
  subscribed,
}) => {
  // 選択状態に応じた境界線のクラス
  const borderClass = subscribed
    ? 'after:border-2 after:border-mi-text-quaternary'
    : checked
    ? 'after:border-2 after:border-mi-text-primary'
    : 'after:border after:border-mi-text-quaternary'

  const titleTextKey = period === 'month' ? 'planCard.monthlyPlan' : 'planCard.yearlyPlan'
  const periodTextKey = period === 'month' ? 'planCard.perMonth' : 'planCard.perYear'

  // クリック時にpriceIdを渡す
  const handleSelect = () => {
    if (subscribed) {
      return
    }
    onSelect(priceId)
  }

  return (
    <div className='relative flex-1'>
      {/*
        擬似要素を使って境界線を表現し、要素のサイズを固定します
        - 相対配置の親要素
        - after擬似要素でボーダーを表現
        - コンテンツのパディングは内側のdivで調整
      */}
      <div
        className={`
          relative cursor-pointer h-full
          after:absolute after:inset-0 after:rounded-lg after:pointer-events-none
          ${borderClass}
        `}
        onClick={handleSelect}
      >
        {/* 内容を表示するための内側のdiv、パディングはここで調整 */}
        <div className={`p-4 ${subscribed && 'bg-mi-bg-surface-secondary rounded-lg'}`}>
          <div className='flex w-full items-center justify-between'>
            <Text color={subscribed ? 'tertiary' : undefined}>
              <MiteneFormattedMessage id={titleTextKey} />
            </Text>
            {!subscribed && <Radio checked={checked} onChange={handleSelect} />}
          </div>

          <div className='mt-1'>
            <div className='mb-1 flex flex-col sm:flex-row sm:items-center sm:gap-1'>
              <Text className='leading-5' bold={true} color={subscribed ? 'tertiary' : undefined}>
                {price}
                {/* できるだけ1つの文章にまとめたいというオーダーがあるため、spanタグが付与されるMiteneFormattedMessageは使わない */}
                <FormattedMessage id={periodTextKey} />
              </Text>
            </div>

            {/* 月あたりの価格表示がない場合も同じ高さを確保するためのdiv */}
            <div>
              {subscribed ? (
                <Text size='small' bold={true} color='tertiary'>
                  <MiteneFormattedMessage id='planCard.subscribed' />
                </Text>
              ) : discountedMonthlyPrice && period === 'year' ? (
                <div className='flex flex-col sm:flex-row sm:items-center sm:gap-1'>
                  <Text size='small' className='leading-4' color='secondary'>
                    {/* できるだけ1つの文章にまとめたいというオーダーがあるため、spanタグが付与されるMiteneFormattedMessageは使わない */}
                    <FormattedMessage id='planCard.monthlyEquivalent' />
                    {discountedMonthlyPrice}
                  </Text>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
